import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

//import theme from '@ecp/common/src/style/theme/default';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Dropdown from '@ecp/common/src/components/dropdown/Dropdown';

import GoodOptionItem from '@fo-pages/good/summary/option/GoodOptionItem';
import { useTheme } from 'styled-components';

const GoodOptionDropdown = ({
  floatingType,
  itemNodeList,
  onSelect,
  handleSelectOptionContainerHeight,
  optionLabelList,
  depth = 0,
  styleProps,
}) => {
  const theme = useTheme();
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    setSelected(null);
  }, [itemNodeList]);

  const itemList = useMemo(() => {
    return itemNodeList.map((item) => ({
      ...item,
      key: item?.itemKey,
      label: item?.itemName,
      disabled: item?.leafItem?.soldOut || item?.leafItem?.stopSale,
    }));
  }, [itemNodeList]);

  const handleSelect = (item) => {
    setSelected(item);
    if (item?.leafItem) {
      onSelect(item?.leafItem);
    }
    handleSelectOptionContainerHeight();
  };

  const dropdownWidth = useMemo(() => {
    return styleProps?.width ? styleProps.width : floatingType ? '300px' : '480px';
  }, [floatingType]);

  return (
    <>
      <FlexBox width={'100%'}>
        {!floatingType && (
          <TextBox flex={'1'} weight={theme.font.weight.medium}>
            {optionLabelList[depth]}
          </TextBox>
        )}
        <FlexBox flex={'4'}>
          <Dropdown
            width={dropdownWidth}
            items={itemList}
            onChange={handleSelect}
            value={selected}
            itemSlot={GoodOptionItem}
            itemsMaxHeight={styleProps?.height}
          />
        </FlexBox>
      </FlexBox>
      {!selected?.leafItem && selected?.childNodeList?.length > 0 && (
        <GoodOptionDropdown
          floatingType={floatingType}
          itemNodeList={selected.childNodeList}
          onSelect={onSelect}
          handleSelectOptionContainerHeight={handleSelectOptionContainerHeight}
          optionLabelList={optionLabelList}
          depth={depth + 1}
          styleProps={styleProps}
        />
      )}
    </>
  );
};

GoodOptionDropdown.propTypes = {
  floatingType: PropTypes.bool,
  itemNodeList: PropTypes.array,
  onSelect: PropTypes.func,
  handleSelectOptionContainerHeight: PropTypes.func,
  optionLabelList: PropTypes.array,
  depth: PropTypes.number,
  styleProps: PropTypes.object,
};
export default GoodOptionDropdown;
